import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faWhatsapp } from '@fortawesome/free-brands-svg-icons';

const SocialIcons: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="fixed bottom-4 right-4 md:bottom-8 md:right-8 z-50 flex flex-col space-y-3 md:space-y-4">
      {/* Google badge only when scrolled */}
      {scrolled && (
        <a
          href="https://www.google.com/maps/place/Cabinet+dentaire+Dr.+Banelhaq+Ayoub/@35.7472832,-5.84238,17z/data=!3m1!4b1!4m6!3m5!1s0xd0b872651725e0b:0xaee4928dbd319fcd!8m2!3d35.7472789!4d-5.8398051!16s%2Fg%2F11xf3rfs_z?entry=ttu&g_ep=EgoyMDI1MDYyOS4wIKXMDSoASAFQAw%3D%3D"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Noter sur Google"
          className="w-8 h-8 md:w-10 md:h-10 lg:w-12 lg:h-12 rounded-full flex items-center justify-center transition-all duration-300 transform hover:scale-110 bg-white border-2 border-[#4285F4] text-[#4285F4] hover:bg-[#4285F4] hover:text-white shadow-2xl"
          style={{ boxShadow: '0 8px 32px 0 rgba(66,133,244,0.18)' }}
          title="Laissez-nous un avis sur Google!"
        >
          <svg className="w-5 h-5 md:w-6 md:h-6 lg:w-7 lg:h-7" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_17_40)">
              <path d="M47.617 24.5455C47.617 22.7336 47.4645 21.0682 47.2327 19.3636H24.48V28.9091H37.6173C37.3645 30.5455 36.2736 32.9091 33.9091 34.5455L33.8755 34.7645L41.3455 40.5455L41.8727 40.6C46.0182 36.8364 47.617 31.2727 47.617 24.5455Z" fill="#4285F4"/>
              <path d="M24.48 47.2727C30.6182 47.2727 35.7091 45.2727 39.8727 40.6L33.9091 34.5455C31.8364 36.0182 29.0182 37.0909 24.48 37.0909C18.491 37.0909 13.2736 33.3091 11.491 27.9636L11.2727 27.9818L3.52727 33.9818L3.41818 34.1818C7.56364 41.3636 15.4182 47.2727 24.48 47.2727Z" fill="#34A853"/>
              <path d="M11.491 27.9636C11.0182 26.5091 10.7455 24.9636 10.7455 23.3636C10.7455 21.7636 11.0182 20.2182 11.4545 18.7636L11.4445 18.5327L3.63636 12.4182L3.41818 12.5455C1.83636 15.5636 0.890909 18.8909 0.890909 23.3636C0.890909 27.8364 1.83636 31.1636 3.41818 34.1818L11.491 27.9636Z" fill="#FBBC05"/>
              <path d="M24.48 9.63636C29.0182 9.63636 32.0182 11.5455 33.7091 13.0909L40.0182 7.01818C35.6909 2.98182 30.6182 0.909088 24.48 0.909088C15.4182 0.909088 7.56364 6.81818 3.41818 12.5455L11.4545 18.7636C13.2736 13.4182 18.491 9.63636 24.48 9.63636Z" fill="#EA4335"/>
            </g>
            <defs>
              <clipPath id="clip0_17_40">
                <rect width="46.8" height="46.8" fill="white" transform="translate(0.890909 0.909088)"/>
              </clipPath>
            </defs>
          </svg>
        </a>
      )}
      <a
        href="https://wa.me/212684707407"
        className={`w-8 h-8 md:w-10 md:h-10 lg:w-12 lg:h-12 rounded-full flex items-center justify-center transition-all duration-300 transform hover:scale-110 animate-fade-in-right animation-delay-600 ${
          scrolled
            ? 'bg-[#25D366] text-white hover:bg-[#1ebe57]'
            : 'bg-white/20 text-white hover:bg-white/30'
        }`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="WhatsApp"
      >
        <FontAwesomeIcon icon={faWhatsapp} className="w-3 h-3 md:w-4 md:h-4 lg:w-5 lg:h-5" />
      </a>
      <a
        href="https://www.instagram.com/dentist_tangier/?igsh=MXE4YzZ0ZDA5dDB6aw%3D%3D#"
        className={`w-8 h-8 md:w-10 md:h-10 lg:w-12 lg:h-12 rounded-full flex items-center justify-center transition-all duration-300 transform hover:scale-110 animate-fade-in-right animation-delay-800 ${
          scrolled
            ? 'bg-primary text-white hover:bg-accent'
            : 'bg-white/20 text-white hover:bg-white/30'
        }`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <FontAwesomeIcon icon={faInstagram} className="w-3 h-3 md:w-4 md:h-4 lg:w-5 lg:h-5" />
      </a>
    </div>
  );
};

export default SocialIcons; 